import FilesWidget from './files-widget'

export type { FilesWidgetProps } from './files-widget'
export default FilesWidget
